import { createContext, useContext } from 'react';

type UnlockDialogContextValue = Readonly<{
  isOpen: boolean;
  handleUnlockDialogOpen: (shouldDisplayFindInvite?: boolean, skipPasswordGate?: boolean) => void;
  onClose: () => void;
  shouldDisplayFindInvite: boolean;
}>;

const UnlockDialogContext = createContext<UnlockDialogContextValue | undefined>(undefined);

const useUnlockDialogContext = () => {
  const context = useContext(UnlockDialogContext);
  if (context === undefined) {
    throw new Error('useUnlockDialogContext must be used within a UnlockDialogProvider');
  }
  return context;
};

export { UnlockDialogContext, useUnlockDialogContext };
export type { UnlockDialogContextValue };
